<app-navbar-style-one></app-navbar-style-one>

<div class="section-title">
    <h2>Add Post</h2>
</div>

<section class="contact-area">
    <div class="container">
        <div class="contact-inner-area">
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="contact-form">
                        <form #contactForm="ngForm" (ngSubmit)="submit(contactForm.value)">
                            <div class="row">
                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group mb-3">
                                        <input required ngModel name="postTitle" type="text" #postTitle="ngModel"
                                            class="form-control custom-border" id="postTitle" placeholder="Post Title">

                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group mb-3">
                                        <input type="file" class="file-input" #fileUploadVehicleReg required
                                            accept=".jpg, .jpeg, .png , .webp"
                                            (change)="onFileSelectedVehicleReg($event)">
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group mb-3">
                                        <textarea required ngModel name="description" #description="ngModel"
                                            class="form-control custom-border" id="description" rows="6"
                                            placeholder="Description"></textarea>
                                    </div>
                                </div>

                                 <div class="col-lg-12 col-md-6">
                                    <div class="form-group mb-3">
                                        Keywords
                                       <input  name="keywords" type="text" #keywords
                                            class="form-control custom-border" id="keywords" placeholder="Keywords">

                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <button type="submit" class="default-btn" [class.disabled]="!contactForm.valid"><i
                                            class='bx bx-paper-plane'></i> SAVE MAIN DETAILS</button>
                                </div>
                            </div>
                        </form>
                        <br>
                        <hr>
                        <h4>Other Details</h4>
                        <br>
                        <form #otherForm="ngForm" >
                            <div class="row">
                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group mb-3">
                                        <input required  name="title" type="text" #title
                                            class="form-control custom-border" id="title" placeholder="Title">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group mb-3">
                                        <input type="file" class="file-input" #img required
                                            accept=".jpg, .jpeg, .png , .webp"
                                            (change)="onFileSelectedVehicleReg($event)">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group mb-3">
                                        <input  name="videoLink" type="text" #videoLink
                                            class="form-control custom-border" id="videoLink" placeholder="Video Link">
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group mb-3">
                                        <textarea required name="otherDescription" #otherDescription
                                            class="form-control" id="otherDescription" rows="6"
                                            placeholder="Description"></textarea>
                                    </div>
                                </div>

                               

                                <div class="col-lg-12 col-md-12">
                                    <button type="submit" class="default-btn" (click)="submitOtherDetails(title.value,videoLink.value,otherDescription.value)" ><i
                                            class='bx bx-paper-plane' ></i> SAVE DETAILS</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-C8F6CSWD62"></script>
<script>
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());

    gtag('config', 'G-C8F6CSWD62');
</script>